import api from '../../services/api';

const baseUrl = 'crm/status'

const findBySellerId = async (sellerId) =>
    api.get({ service: `${baseUrl}/${sellerId}` });

export default {
    findBySellerId,
}